import React from 'react'
import { EChipModifier } from '@frontend/pole-ui/lib/components/Chip'
import { Modal } from '@frontend/ui-kit/agromarket/components/Modal'
import { Text } from '@frontend/ui-kit/agromarket/components/Text'
import classNames from 'classnames'
import Badge from '@/components/composed/financing/Badge/Badge'
import { Button, Image } from '@/components/ui'
import { FieldEvaluationReportDialog } from '@/pages/Financing/components/FieldEvaluationReportDialogLauncher/components/FieldEvaluationReportDialog/FieldEvaluationReportDialog'
import { useWebpExtension } from '@/utils/hooks/image'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { messages } from './messages'
import type { TIncreaseLoanAmountBannerProps } from './types'
import './styles.scss'

export const LoanProductsFieldEvaluationReportBanner: React.FC<TIncreaseLoanAmountBannerProps> = ({ className }) => {
  const extension = useWebpExtension()
  const { isMobile } = useDeviceType()

  const handleClick = () => {
    Modal.show(FieldEvaluationReportDialog, {
      comment: messages.comment,
    })
  }

  return (
    <div className={classNames('loanProductsFieldEvaluationReportBanner', className)}>
      <Image
        className="loanProductsFieldEvaluationReportBanner__image"
        src={`fieldEvaluationReportBanner/satellite.${extension}`}
        isInStatic
      />
      <div className="loanProductsFieldEvaluationReportBanner__text">
        <Text variant="heading" size={isMobile ? 'sm' : 'md'} className="loanProductsFieldEvaluationReportBanner__title" as="h6">
          {messages.title}
        </Text>
        <Badge
          className="loanProductsFieldEvaluationReportBanner__subtitle text_super-small"
          text={messages.subtitle}
          color={EChipModifier.LIGHT_GREEN}
        />
      </div>
      <Button
        className="loanProductsFieldEvaluationReportBanner__action"
        modifiers={isMobile ? ['green', 'small', 'full-width-mobile'] : ['green']}
        onClick={handleClick}
      >
        {messages.action}
      </Button>
    </div>
  )
}
